/**
 * Indica si un token de acceso ya venció.
 *
 * El sistema no renueva el token: cuando caduca, la primera llamada a la API
 * cierra la sesión. Los WebSockets no pasan por esa validación, así que sin
 * esta comprobación se quedan reintentando para siempre con un token muerto y
 * el tiempo real muere en silencio.
 *
 * @param {String} token - Token de acceso a evaluar.
 * @return {Boolean} True si ya no sirve para conectar.
 */
export const isTokenExpired = (token) => {
  if (!token) return true

  try {
    const payload = JSON.parse(
      atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))
    )
    // Un token sin vencimiento declarado no se bloquea
    if (!payload.exp) return false
    return payload.exp * 1000 <= Date.now()
  } catch (e) {
    // Si no se puede leer, tampoco sirve para conectar
    return true
  }
}

export default {
  namespaced: true,
  state: {
    token: localStorage.getItem('token') || '',
    refresh_token: localStorage.getItem('refresh_token') || '',
    me: JSON.parse(localStorage.getItem('me')) || ''
  },
  getters: {
    token: (state) => state.token,
    isAuth: (state) => !!state.token,
    me: (state) => {
      return state.me
    },
    isAdmin: (state) =>
      state.me.is_staff === undefined ? false : state.me.is_staff,
    getPermissions: (state) => (permission) =>
      !Array.isArray(permission)
        ? false
        : state.me.get_all_permissions != undefined
        ? state.me.get_all_permissions.filter((m) => permission.includes(m))
            .length > 0
        : '',
    darkMode: (state) => {
      if (state.me.profile === undefined || state.me.profile === null)
        return false
      return state.me.profile.darkMode
    }
  },
  mutations: {
    login: (state, token, refresh) => {
      state.token = token
      state.refresh_token = refresh
    },
    logout: (state) => {
      state.token = ''
      state.refresh_token = ''
      state.me = ''
    },
    setMe(state, me) {
      localStorage.setItem('me', JSON.stringify(me))
      state.me = me
    }
  },
  actions: {
    logout: ({ commit }) => {
      commit('logout')
      commit('company/resetCompany', null, { root: true })
      commit('formula/resetFormulas', null, { root: true })
      commit('sales/resetSales', null, { root: true })
      commit('whatsapp/resetWhatsapp', null, { root: true })

      const keepKeys = ['locale']
      const keysToRemove = [
        'token',
        'refresh_token',
        'me',
        'company',
        'dateFormat',
        'currency',
        'currencies',
        'customerToSale',
        'componentKey',
        'updatedKey',
        'subdomain',
        'subdomainid',
        'subdomainschema'
      ]
      keysToRemove.forEach((key) => localStorage.removeItem(key))

      if (typeof document !== 'undefined') {
        const root = document.documentElement
        root.style.setProperty('--primary', '#3073C9')
        root.style.setProperty('--secundary', '#345d48')
        root.style.setProperty('--text-color', '#fff')
        root.style.setProperty('--text-color-secondary', '#fff')
      }

      delete window.axios.defaults.headers['Authorization']
    },
    login: ({ commit }, data) => {
      localStorage.setItem('token', data.token)
      localStorage.setItem('refresh_token', data.refresh)
      window.axios.defaults.headers['Authorization'] = `Bearer ${data.token}`
      commit('login', data.token, data.refresh)
    }
  }
}
